import moment from 'moment';
import constants from 'Constants';


export function getProptype(proptypes, accessor) {
  let proptype = null;
  proptypes.forEach((rowProptype) => {
    if (proptype) return;
    if (rowProptype.accessor === accessor) {
      proptype = rowProptype;
      return;
    }

    if (rowProptype.hasLineItems) {
      rowProptype.lineItemPropertyTypes.forEach((liProptype) => {
        if (proptype) return;
        if (liProptype.accessor === accessor) {
          proptype = liProptype;
          return;
        }
      })
    }
  })

  return proptype;
}


export function getFlattenedProptypeBpItems(proptypes) {
  const bpItems = [];
  proptypes.forEach((proptype) => {
    if (proptype.isValueTypeDict) return;
    if (!proptype.hasLineItems) {
      bpItems.push({
        'key': proptype.accessor,
        'text': proptype.label,
        'label': proptype.valueTypeDisplay,
      })
      return;
    }

    proptype.lineItemPropertyTypes.forEach((liProptype) => {
      if (liProptype.isValueTypeDict) return;
      bpItems.push({
        'key': liProptype.accessor,
        'text': `${proptype.label} > ${liProptype.label}`,
        'label': liProptype.valueTypeDisplay,
      })
    })
  })

  return bpItems;
}


export function deserializePropertyValues(valueType, predicate, values) {
  values = values.slice();

  if (valueType === constants.PROPERTY_VALUE_TYPE_DATETIME) {
    if (predicate === constants.PREDICATE_DATETIME_LESS_THAN_HOURS_AGO) values[0] = values[0].toString();
    if (predicate === constants.PREDICATE_DATETIME_MORE_THAN_HOURS_AGO) values[0] = values[0].toString();
    if (predicate === constants.PREDICATE_DATETIME_LESS_THAN_DAYS_AGO) values[0] = values[0].toString();
    if (predicate === constants.PREDICATE_DATETIME_MORE_THAN_DAYS_AGO) values[0] = values[0].toString();
    if (predicate === constants.PREDICATE_DATETIME_BETWEEN_DAYS_AGO) {
      values[0] = values[0].toString();
      values[1] = values[1].toString();
    }

    if (predicate === constants.PREDICATE_DATETIME_MATCH_DATE) values[0] = moment.unix(values[0]).utc();
    if (predicate === constants.PREDICATE_DATETIME_BEFORE_DATE) values[0] = moment.unix(values[0]).utc();
    if (predicate === constants.PREDICATE_DATETIME_AFTER_DATE) values[0] = moment.unix(values[0]).utc();
    if (predicate === constants.PREDICATE_DATETIME_BETWEEN_DATES) {
      values[0] = moment.unix(values[0]).utc();
      values[1] = moment.unix(values[1]).utc();
    }
  }

  if (valueType === constants.PROPERTY_VALUE_TYPE_NUMBER) {
    values = values.map((value) => value.toString());
  }

  return values;
}

export function deserializeWithProptype(data, proptypes) {
  if (proptypes.length === 0) return data.values;

  const accessor = data.accessor || data.proptype_accessor;
  const proptype = getProptype(proptypes, accessor);
  if (!proptype) return data.values;

  let valueType = proptype.valueType;
  let predicate = data.predicate;
  let values = data.values.slice();
  values = deserializePropertyValues(valueType, predicate, values);
  return values;
}


export function serializePropertyValues(valueType, predicate, values) {
  values = values.slice();

  if (valueType === constants.PROPERTY_VALUE_TYPE_DATETIME) {
    if (predicate === constants.PREDICATE_DATETIME_MATCH_DATE) values[0] = values[0].unix();
    if (predicate === constants.PREDICATE_DATETIME_BEFORE_DATE) values[0] = values[0].unix();
    if (predicate === constants.PREDICATE_DATETIME_AFTER_DATE) values[0] = values[0].unix();
    if (predicate === constants.PREDICATE_DATETIME_BETWEEN_DATES) {
      values[0] = values[0].unix();
      values[1] = values[1].unix();
    }
  }

  return values;
}


export function serializeWithProptype(data, proptypes) {
  const accessor = data.accessor || data.proptype_accessor;
  const proptype = getProptype(proptypes, accessor);
  if (!proptype) return data;

  let valueType = proptype.valueType;
  let predicate = data.predicate;
  let values = data.values.slice();
  values = serializePropertyValues(valueType, predicate, values);

  data['values'] = values;
  return data;
}


export function getPropertyDefaultValues(valueType, predicate) {
  let values = [];
  let emptyValueTypes = [
    constants.PROPERTY_VALUE_TYPE_BOOLEAN,
    constants.PROPERTY_VALUE_TYPE_STRING,
    constants.PROPERTY_VALUE_TYPE_STRING_ARRAY,
  ];

  if (emptyValueTypes.includes(valueType)) {
    return values;
  }

  if (valueType === constants.PROPERTY_VALUE_TYPE_NUMBER) {
    if (predicate === constants.PREDICATE_NUMBER_EQUALS) values = [""];
    if (predicate === constants.PREDICATE_NUMBER_NOT_EQUALS) values = [""];
    if (predicate === constants.PREDICATE_NUMBER_LESS_THAN) values = [""];
    if (predicate === constants.PREDICATE_NUMBER_LESS_THAN_OR_EQUAL) values = [""];
    if (predicate === constants.PREDICATE_NUMBER_GREATER_THAN) values = [""];
    if (predicate === constants.PREDICATE_NUMBER_GREATER_THAN_OR_EQUAL) values = [""];
    return values;
  }

  if (valueType === constants.PROPERTY_VALUE_TYPE_DATETIME) {
    if (predicate === constants.PREDICATE_DATETIME_LESS_THAN_HOURS_AGO) values = [""];
    if (predicate === constants.PREDICATE_DATETIME_MORE_THAN_HOURS_AGO) values = [""];
    if (predicate === constants.PREDICATE_DATETIME_LESS_THAN_DAYS_AGO) values = ["", "UTC"];
    if (predicate === constants.PREDICATE_DATETIME_MORE_THAN_DAYS_AGO) values = ["", "UTC"];
    if (predicate === constants.PREDICATE_DATETIME_BETWEEN_DAYS_AGO) values = ["", "", "UTC"];
    if (predicate === constants.PREDICATE_DATETIME_MATCH_DATE) values = ["", "UTC"];
    if (predicate === constants.PREDICATE_DATETIME_BEFORE_DATE) values = ["", "UTC"];
    if (predicate === constants.PREDICATE_DATETIME_AFTER_DATE) values = ["", "UTC"];
    if (predicate === constants.PREDICATE_DATETIME_BETWEEN_DATES) values = ["", "","UTC"];
    return values;
  }

  return [];
}

export function getDefaultValuesWithProptype(accessor, predicate, proptypes) {
  const proptype = getProptype(proptypes, accessor);
  if (!proptype || !predicate) return [];

  let valueType = proptype.valueType;
  let values = getPropertyDefaultValues(valueType, predicate);
  return values;
}

export function checkPredicateRequireValues(predicate) {
  if (predicate.startsWith('BOOLEAN_')) return false;
  if (predicate.endsWith('_KNOWN')) return false;
  if (predicate.endsWith('_UNKNOWN')) return false;
  if (predicate.endsWith('OVER_ALL_TIME')) return false;
  return true;
}
